/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_49a94057"]'><cube-button primary>主要按钮</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_49a94057"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_49a94057"}
  /** script content **/
  require("./btn-primary.mpx.js?isComponent&outputPath=components%2Fbtn-primary49a94057%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-primary.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-primary49a94057%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_49a94057"],
    ctorType: "component",
    outputPath: "components/btn-primary49a94057/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>